import React, { useEffect, useState } from "react"
import { colors, fonts } from "../Styles"
import { useTranslation } from "react-i18next";

interface MenuButton_Props {
  menuState: boolean
  onClick: () => void
  focus_view?: boolean
}

export default function MenuButton({menuState, onClick, focus_view }:MenuButton_Props) {
  const {t} = useTranslation();
  const [isMenuOpen, setMenuOpen] = useState<boolean>(menuState)
  
  useEffect(() => {
    setMenuOpen(menuState)
  }, [menuState])

  const _lineStyle: React.CSSProperties = {   
    width: "100%",
    height: "3px",
    backgroundColor: colors.greyLightTertiary,
    transition: "all 0.3s ease",
    borderRadius: "10px"
  }

  const MenuIcon = (
    <div style={{width: "25px", height: "17px", display: "flex", flexDirection: "column", justifyContent: "space-between"}}>
      <div style={{..._lineStyle, transform: isMenuOpen? "rotate(45deg) translate(5px, 5px)" : "rotate(0deg) translate(0px, 0px)" }}/>
      <div style={{..._lineStyle, opacity: isMenuOpen? "0" : "1"}}/>
      <div style={{..._lineStyle, transform: isMenuOpen? "rotate(-45deg) translate(5px, -5px)" : "rotate(0deg) translate(0px, 0px)"}}/>
    </div>
  )
  
  return (
    <button onClick={onClick} style={{ 
      display: "flex", 
      alignItems: "center", 
      justifyContent:"center", 
      flexDirection: "column",
      position: "absolute", 
      bottom: "10px", 
      left: "0px", 
      width: focus_view ? "70px" : "60px", 
      height: focus_view ? "70px" : "60px", 
      backgroundColor: colors.blueDarkPrimary+"cc", 
      borderStyle: "solid",
      borderColor: colors.blueDarkPrimary,
      borderWidth: "2px 2px 2px 0px",
      borderRadius: "0 10px 10px 0", 
      cursor: "pointer", 
      zIndex: isMenuOpen? "9999999" : "999",
      gap: "5px",
      backdropFilter: "blur(2px)",
      WebkitTapHighlightColor: "transparent",
    }}>
      {MenuIcon}
      <p style={{...fonts.header, ...(focus_view ? fonts.fontSize3 : fonts.fontSize4), color: colors.greyLightTertiary}}>{t("buttons.menu", {defaultValue: "menu"})}</p>
    </button>
  )
}